
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/class/directory",
      function () {
        return require("private-next-pages/class/directory.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/class/directory"])
      });
    }
  